export var API_ENDPOINT_DEV = 'https://api-testnet.niftykit.com';
export var API_ENDPOINT = 'https://api.niftykit.com';
